import React, { useState } from 'react';
import Header from '../components/Header';
import StatisticsPanel from '../components/StatisticsPanel';
import NotificationPanel from '../components/NotificationPanel';
import DeliveryCard from '../components/DeliveryCard';
import { deliveries } from '../data/mockData';

const Dashboard: React.FC = () => {
  const [activeDeliveries, setActiveDeliveries] = useState(deliveries);
  const [notificationCount, setNotificationCount] = useState(0);
  
  // Fonction pour mettre à jour le poids d'une livraison
  const handleWeightUpdate = (id: number, weight: number) => {
    console.log(`Mise à jour du poids pour la livraison #${id}: ${weight} kg`);
    // Dans une vraie application, on enverrait cette donnée à l'API
    setNotificationCount(prev => prev + 1);
  };
  
  // Fonction pour envoyer un SMS
  const handleSendSMS = (id: number, phone: string) => {
    console.log(`Envoi d'un SMS pour la livraison #${id} au numéro ${phone}`);
    // Dans une vraie application, on enverrait cette demande à l'API
    setNotificationCount(prev => prev + 1);
  };
  
  return (
    <div className="min-h-screen bg-gray-100">
      <Header />
      
      <main className="container mx-auto px-4 py-8">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-bold text-gray-800">Tableau de bord</h1>
          <div className="flex space-x-2">
            <button className="px-4 py-2 bg-white border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50">
              Exporter
            </button>
            <button className="px-4 py-2 bg-blue-600 border border-transparent rounded-md shadow-sm text-sm font-medium text-white hover:bg-blue-700">
              Actualiser
            </button>
          </div>
        </div>
        
        {/* Statistiques */}
        <StatisticsPanel />
        
        {/* Contenu principal */}
        <div className="mt-8 grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Liste des livraisons */}
          <div className="lg:col-span-2 space-y-6">
            <div className="bg-white p-4 rounded-lg shadow-md">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-lg font-medium text-gray-900">Livraisons du jour</h2>
                <div className="flex space-x-2">
                  <select className="border border-gray-300 rounded-md shadow-sm py-2 px-3 bg-white text-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500">
                    <option>Toutes</option>
                    <option>En cours</option>
                    <option>En attente</option>
                    <option>Terminées</option>
                    <option>Planifiées</option>
                  </select>
                  <button className="p-2 rounded-md bg-gray-100 hover:bg-gray-200">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-500" viewBox="0 0 20 20" fill="currentColor">
                      <path d="M5 4a1 1 0 00-2 0v7.268a2 2 0 000 3.464V16a1 1 0 102 0v-1.268a2 2 0 000-3.464V4zM11 4a1 1 0 10-2 0v1.268a2 2 0 000 3.464V16a1 1 0 102 0V8.732a2 2 0 000-3.464V4zM16 3a1 1 0 011 1v7.268a2 2 0 010 3.464V16a1 1 0 11-2 0v-1.268a2 2 0 010-3.464V4a1 1 0 011-1z" />
                    </svg>
                  </button>
                </div>
              </div>
              
              <div className="space-y-4">
                {activeDeliveries.map(delivery => (
                  <DeliveryCard 
                    key={delivery.id} 
                    delivery={delivery} 
                    onWeightUpdate={handleWeightUpdate}
                    onSendSMS={handleSendSMS}
                  />
                ))}
              </div>
            </div>
          </div>
          
          {/* Panneau latéral */}
          <div className="space-y-6">
            {/* Notifications */}
            <NotificationPanel />
            
            {/* Résumé de la journée */}
            <div className="bg-white rounded-lg shadow-md p-5">
              <h3 className="font-semibold text-lg mb-4">Résumé de la journée</h3>
              
              <div className="space-y-4">
                <div>
                  <h4 className="text-sm font-medium text-gray-500">Total des livraisons</h4>
                  <p className="text-2xl font-bold">{deliveries.length}</p>
                </div>
                
                <div className="pt-4 border-t border-gray-200">
                  <h4 className="text-sm font-medium text-gray-500">Poids total transporté</h4>
                  <p className="text-2xl font-bold">16 100 kg</p>
                </div>
                
                <div className="pt-4 border-t border-gray-200">
                  <h4 className="text-sm font-medium text-gray-500">Distance totale parcourue</h4>
                  <p className="text-2xl font-bold">287 km</p>
                </div>
                
                <div className="pt-4 border-t border-gray-200">
                  <h4 className="text-sm font-medium text-gray-500">Temps moyen de livraison</h4>
                  <p className="text-2xl font-bold">42 min</p>
                </div>
              </div>
              
              <button className="mt-6 w-full bg-gray-100 hover:bg-gray-200 text-gray-800 font-medium py-2 px-4 rounded-md transition-colors">
                Voir le rapport complet
              </button>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Dashboard;
